/** @format */
import styled from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { Link } from '@toucan/client/shared/components/link';

export const MarketSelectorWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: var(--layout-spacing-8);
`;

export const MarketSelectorLink = styled(Link)`
    ${theme.typography.body_small_highlight};
`;
